import { useQuery } from '@tanstack/react-query';
import { getCoreRowModel, useReactTable } from '@tanstack/react-table';
import React, { useEffect, useState } from 'react';
import { useActivityColumns } from '@/app/[locale]/(landing)/components/latest-activity/columns';
import { fetchNewRow, type tabKeyType } from '@/app/[locale]/(landing)/components/latest-activity/data';
import TableView from '@/components/common/table';

type LiveTableProps = {
  selectedTab: tabKeyType;
};

const LatestActivityTable = ({ selectedTab }: LiveTableProps) => {
  const [casinoBetsData, setCasinoBetsData] = useState<any[]>([]);
  const [sportsBetsData, setSportsBetsData] = useState<any[]>([]);
  const columns = useActivityColumns(selectedTab);

  const { data: newRow, isLoading } = useQuery({
    queryKey: [selectedTab],
    queryFn: () => fetchNewRow(selectedTab),
    refetchInterval: 300,
  });

  useEffect(() => {
    if (newRow) {
      if (selectedTab === 'CASINO_BETS') {
        setCasinoBetsData((prev) => [newRow, ...prev.slice(0, 9)]); // keep max 10 rows
      } else if (selectedTab === 'SPORTS_BETS') {
        setSportsBetsData((prev) => [newRow, ...prev.slice(0, 9)]); // keep max 10 rows
      }
    }
  }, [newRow, selectedTab]);

  // Get the appropriate data based on the selected tab
  const currentData = selectedTab === 'CASINO_BETS' ? casinoBetsData : sportsBetsData;

  const table = useReactTable({ data: currentData || [], columns, getCoreRowModel: getCoreRowModel() });

  return (
    <TableView
      table={table}
      isLoading={isLoading}
      skeletonRows={7}
      isLiveMode
      tableBodyClassName="!vt-body-bg min-h-[350px] sm:min-h-[450px]"
      cellClassName="min-h-10"
      rowClassName={(rowIndex: number) =>
        rowIndex % 2 === 0 ? 'h-11 vt-containers-settings-box-normal-bg' : 'h-11 vt-body-bg'
      }
    />
  );
};

export default LatestActivityTable;
